import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: ${( props ) => props.theme.v2.palette[ 'TAG1-700' ]} 2px solid;
  border-radius: 28px 28px 28px 28px;
`

export const DesktopWrapper = styled.div`
  .plan-selector-label {
    font-family: ${( props ) => props.theme.fontFamily.notoSans};
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;

    padding: 10px 50px;
  }

  .plan-selector-discount-badge {
    left: 50px;
  }
`

export const Input = styled.input`
  display: none;
`

export const Label = styled.label<{ isSelected: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;

  font-family: ${( props ) => props.theme.fontFamily.notoSans};
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 5%;
  text-transform: uppercase;

  cursor: pointer;
  color: ${( props ) => ( props.isSelected ? '#f9f6ef' : props => props.theme.v2.palette[ 'TAG1-700' ] )} !important;
  background-color: ${( props ) => ( props.isSelected ? props => props.theme.v2.palette[ 'TAG1-700' ] : '#f9f6ef' )} !important;
  transition: background-color 0.3s, color 0.3s;
  border-radius: 28px 28px 28px 28px;
  min-width: 140px;
`

export const BadgeWrapper = styled.div`
  position: relative;
`

export const DiscountBadge = styled.span`
  position: absolute;
  left: 23px;
  top: -23px;
  transform: rotate(6.05deg);
  background-color: #e16d00;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 5px;
`
